export default __webpack_public_path__ + "static/media/arrival-new.0d6f1657.svg";